module.exports = __webpack_public_path__ + "img/第2章_2-2_公會堂謎題圖.jpg";